module.exports = __webpack_public_path__ + "static/partners-fc3b9a28b2f3c72736f6171abd466dff.jpg";